<template>
  <div class="modal--addUser">
    <div class="modalCustom__header">
      <h5 class="">{{ data.header }}</h5>
      <hr class="modalCustom__header-border" />
    </div>

    <div v-if="data.company" class="modalCustom__body">
      <!-- Select Part -->
      <p>
        For company <span class="text-primary">{{ data.company.name }}</span>
      </p>
      <div class="pt-4">
        <multiselect
          v-model="selected_certificates"
          :options="certificates"
          :loading="loading"
          track-by="id"
          label="name"
          :searchable="true"
          :multiple="false"
          :close-on-select="true"
          :show-labels="false"
        >
          <template slot="singleLabel" slot-scope="props">
            <div class="option">
              <img class="certificate__img option__img" :src="props.option.img_url" alt="Certificate img" />
              <div class="option__desc">
                <span class="option__title">{{ props.option.name }}</span>
                <span class="option__small">{{ props.option.provider.name }}</span>
              </div>
            </div>
          </template>
          <template slot="option" slot-scope="props">
            <div class="option">
              <img class="certificate__img option__img" :src="props.option.img_url" alt="Certificate img" />
              <div class="option__desc">
                <span class="option__title">{{ props.option.name }}</span>
                <span class="option__small">{{ props.option.provider.name }}</span>
              </div>
            </div>
          </template>
        </multiselect>
      </div>
      <!-- End Select Part -->
    </div>

    <div class="modalCustom__footer">
      <!--            buttons                   -->
      <div class="mr-3">
        <p-button type="danger" round @click.native.prevent="closeModal">
          {{ $t('Cancel') }}
        </p-button>
      </div>
      <div>
        <p-button type="success" round @click.native.prevent="addCertificate">
          {{ $t('save') }}
        </p-button>
      </div>
    </div>
  </div>
</template>

<script>
import CertificateController from '../../controllers/Certificates/CertificateController';

export default {
  name: 'AssignCertificateModal',
  props: {
    data: {
      company: Object,
    },
  },
  data: function () {
    return {
      selected_certificates: null,
      certificates: [],
      loading: false,
    };
  },
  async beforeMount() {
    this.loading = true;
    await this.setCertificates();
    this.loading = false;
  },
  methods: {
    closeModal: function () {
      this.selected_certificates = null;
      this.$emit('close');
    },
    addCertificate: function () {
      this.$emit('submit', this.selected_certificates);
      this.closeModal();
    },
    async setCertificates() {
      return (this.certificates = await CertificateController.index());
    },
  },
};
</script>

<style scoped></style>
